import {
  getActivitiesRequest,
  getUsersRequest,
  getExportExcelRequest,
} from "_data/services/admin/service";

export const useAdmin = () => {
  const getListUsersData = (callback = () => {}) => {
    getUsersRequest((success, response) => {
      callback(success, response);
    });
  };
  const getListActivitiesData = (callback = () => {}) => {
    getActivitiesRequest((success, response) => {
      callback(success, response);
    });
  };
  const getExportExcelData = (callback = () => {}) => {
    getExportExcelRequest((success, blob, fileName) => {
      callback(success, blob, fileName);
    });
  };
  return { getListUsersData, getListActivitiesData, getExportExcelData };
};
